import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface FlowCancelConfirmDialogProps {
  open: boolean;
  onStay: () => void;
  onConfirmCancel: () => void;
  title?: string;
  description?: string;
  confirmText?: string;
  /** Disables the buttons (e.g. while a submission is in flight). */
  locked?: boolean;
}

/**
 * Confirms abandoning a verification flow. Ports the legacy
 * FlowCancelConfirmDialog — replaces bare window.confirm() in the flows.
 */
export function FlowCancelConfirmDialog({
  open,
  onStay,
  onConfirmCancel,
  title = 'Cancel verification?',
  description = 'This will abandon your current verification flow and clear your progress.',
  confirmText = 'Cancel and exit',
  locked = false,
}: FlowCancelConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onStay()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={onStay} disabled={locked}>
            Stay
          </Button>
          <Button variant="destructive" onClick={onConfirmCancel} disabled={locked} autoFocus>
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
